(function($) {
  'use strict';
  var $modalFormTrigger = $('.js-modal-form-trigger'),
    initialWidth = window.innerWidth,
    initialHeight = window.innerHeight;

  if ($modalFormTrigger.length) {
    var cboxOptions = $.extend(
      {
        width: '100%',
        height: '100%',
        maxWidth: '600px',
        maxHeight: '725px'
      },
      $modalFormTrigger.data()
    );
    $modalFormTrigger.colorbox(cboxOptions);

    $(window).on('resize', function() {
      var innerWidth = window.innerWidth;
      var innerHeight = window.innerHeight;
      if (innerHeight === initialHeight && innerWidth === initialWidth) {
        setTimeout(function() {
          $.colorbox.resize({
            width: initialWidth,
            height: initialHeight
          });
        }, 100);
      }
    });
  }
})(jQuery);
